import { translate, type UiLanguage } from "./i18n/translations";

const SAFE_AUTH_MESSAGE = "Your session has expired or changed. Please log in again to continue. This can happen for security reasons or if you signed in on another device.";
function currentLanguage(): UiLanguage {
  try {
    const token = localStorage.getItem("elume_token");
    const payload = token ? JSON.parse(atob(token.split(".")[1])) : null;
    const account = payload?.email ?? payload?.sub ?? payload?.username;
    const accountKey = typeof account === "string" && account.trim() ? account.trim().toLowerCase() : "anonymous";
    const stored = localStorage.getItem(`elume_ui_language_v2:${accountKey}`);
    const parsed = stored && JSON.parse(stored);
    if (parsed?.language === "ga") return "ga";
    return localStorage.getItem(`elume_ui_language_v1:${accountKey}`) === "ga" ? "ga" : "en";
  } catch {
    return "en";
  }
}

/** Keeps arbitrary caught payloads out of the UI, while localising only stable
 * application-owned fallbacks and known safe messages. */
export function userFacingError(error: unknown, fallback: string): string {
  const language = currentLanguage();
  if (error instanceof Error) {
    if (error.message === SAFE_AUTH_MESSAGE) return translate(language, "error.sessionChanged");
    if (error.message === "Choose a category first") return translate(language, "error.chooseCategory");
    if (error.message === "Enter a category name") return translate(language, "error.enterCategoryName");
  }
  return language === "ga" ? translate("ga", "error.requestFallback") : fallback;
}
